import { formatDistanceToNow, formatDistanceToNowStrict } from 'date-fns';
import type { FormatDistanceToNowOptions, FormatDistanceToNowStrictOptions } from 'date-fns';

/**
 * Safe wrappers for parse-and-format operations.
 * Swallow errors silently, return fallback, let the component always render.
 */

/** Safely call formatDistanceToNow(). Returns fallback on any error. */
export function safeDistanceToNow(
  value: string | number | Date | null | undefined,
  options?: FormatDistanceToNowOptions,
  fallback = '',
): string {
  if (value == null || value === '') return fallback;
  try {
    const d = new Date(value);
    if (isNaN(d.getTime())) return fallback;
    return formatDistanceToNow(d, options);
  } catch {
    return fallback;
  }
}

/** Safely call formatDistanceToNowStrict(). Returns fallback on any error. */
export function safeDistanceToNowStrict(
  value: string | number | Date | null | undefined,
  options?: FormatDistanceToNowStrictOptions,
  fallback = '',
): string {
  if (value == null || value === '') return fallback;
  try {
    const d = new Date(value);
    if (isNaN(d.getTime())) return fallback;
    return formatDistanceToNowStrict(d, options);
  } catch {
    return fallback;
  }
}

/** Safely parse JSON. Returns fallback on SyntaxError. */
export function safeJsonParse<T>(value: string | null | undefined, fallback: T): T {
  if (value == null || value === '') return fallback;
  try {
    return JSON.parse(value) as T;
  } catch {
    return fallback;
  }
}
